import { Session } from './user';

export const VISITOR: Session = {
  id: '',
  email: '',
  name: '',
  roles: [],
  fileCount: 0,
  threads: [],
  organizations: [
    {
      id: '',
      name: '',
      slug: '',
      logo: '',
      suggestions: [],
    },
  ],
};
